import { render, staticRenderFns } from "./Render.vue?vue&type=template&id=f8f2ec54"
import script from "./Render.vue?vue&type=script&lang=ts"
export * from "./Render.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports